// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"73048586","130":"0c441a09","259":"812c1c8d","468":"a6903c1f","515":"f7ecc9d8","545":"70375b30","987":"ee35911c"}[chunkId] + ".chunk.js";
};